// =============================================================================
// PageHeader — shared page-level header with optional back button
//
// Used across: home, inspections index, administration index, and any other
// page with a standard title + optional back navigation pattern.
// =============================================================================

import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

export interface PageHeaderProps {
	title: string
	description?: string
	/** When provided, renders a back arrow button that calls this handler */
	onBack?: () => void
	/** Extra classes on the wrapper div (e.g. to override bottom margin) */
	className?: string
}

export const PageHeader = ({
	title,
	description,
	onBack,
	className,
}: PageHeaderProps) => {
	const defaultMargin = onBack ? 'mb-6' : 'mb-8'

	return (
		<div className={className ?? defaultMargin}>
			{onBack ? (
				<div className="flex items-start gap-3">
					<Button
						variant="ghost"
						size="icon"
						onClick={onBack}
						className="mt-1 size-9 shrink-0"
					>
						<ArrowLeft className="size-5" />
					</Button>
					<div>
						<h1 className="text-2xl font-semibold text-kaefer-dark-grey sm:text-3xl">
							{title}
						</h1>
						{description && (
							<p className="mt-1 text-sm text-muted-foreground">
								{description}
							</p>
						)}
					</div>
				</div>
			) : (
				<div>
					<h1 className="text-2xl font-bold text-kaefer-dark-grey sm:text-3xl">
						{title}
					</h1>
					{description && (
						<p className="mt-1 text-sm text-muted-foreground">{description}</p>
					)}
				</div>
			)}
		</div>
	)
}
